/**
 * Preserve Shopify's draft-theme preview context when a browser/session does
 * not retain it automatically. This runs only when preview_theme_id is already
 * present in the current URL and has no effect on the published storefront.
 */
(function preserveDeoxyThemePreviewNavigation() {
  const current = new URL(window.location.href);
  const previewThemeId = current.searchParams.get('preview_theme_id');

  if (!previewThemeId) return;

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const anchor = event.target.closest('a[href]');

      if (!(anchor instanceof HTMLAnchorElement)) return;
      if (anchor.target === '_blank' || anchor.hasAttribute('download')) return;

      const target = new URL(anchor.href, window.location.origin);

      if (target.origin !== window.location.origin) return;
      if (!target.pathname.startsWith('/products/')) return;
      if (target.searchParams.has('preview_theme_id')) return;

      target.searchParams.set('preview_theme_id', previewThemeId);
      anchor.href = target.toString();
    },
    true
  );
})();